import { useSelfHiringContext } from "@/app/contexts/SelfHiringContext";
import { Button } from "@/view/components/ui/button";
import { CheckCircle } from "lucide-react";
import { useFormContext } from "react-hook-form";
import { toast } from "@/view/components/ui/use-toast";
import { useQuery } from "@tanstack/react-query";
import { TickCircle } from "iconsax-react";
import { PanLinkResponse } from "@/app/services/panService/getLink";
import { selfHireService } from "@/app/services/selfHireService";

export const Formalization = () => {
  const { cleanFormData, panData } = useSelfHiringContext();
  const methods = useFormContext();

  const { data, isLoading, isError } = useQuery<PanLinkResponse>({
    queryKey: ["panSelfHiringLink", panData?.state.transactionId],
    queryFn: () =>
      selfHireService.getLinkFormalize(panData?.state.transactionId!),
    enabled: !!panData?.state.transactionId,
  });

  const handleBackToInitial = () => {
    methods.reset({});
    cleanFormData();
  };

  const copyLink = () => {
    if (data?.linkCliente) {
      toast({
        title: "Link da proposta copiado",
      });
    }
  };

  return (
    <div className="flex w-full flex-col items-center justify-center gap-6 rounded-xl border border-gray02 bg-white01 p-4 py-10 text-center">
      <CheckCircle className="h-14 w-14 text-green-600" />

      <div className="flex flex-col gap-1">
        <h1 className="text-xl font-bold">Contrato finalizado com sucesso</h1>
      </div>

      {data?.linkCliente && (
        <>
          <div className="mt-10 flex flex-col items-start gap-1.5 px-6">
            <TickCircle variant="Bold" size={40} className="text-success" />
            <strong className="font-semibold">Proposta realizada</strong>
            <p className="text-sm font-medium text-black04">
              Copie o link para finalizar a financeira.
              {/* Você será avisado quando o processo for concluído. */}
            </p>
          </div>
          <div className="mt-6 flex justify-end gap-2">
            <Button
              variant="outline"
              className="w-[200px] rounded-full text-primary"
              onClick={copyLink}
              disabled={isLoading || isError || !data?.linkCliente}
            >
              Copiar link
            </Button>
          </div>
        </>
      )}

      <div className="mt-4 flex flex-col gap-2">
        <Button
          onClick={handleBackToInitial}
          className=" w-36 rounded-2xl font-semibold text-white "
        >
          Voltar ao Início
        </Button>
      </div>
    </div>
  );
};
